import { reactive, inject, InjectionKey, provide } from '@vue/composition-api'

export type VideoPlayState = 'paused' | 'stopped' | 'playing'

export interface VideoState {
  timecode: number
  playState: VideoPlayState
}

export const VideoStateKey: InjectionKey<VideoState> = Symbol('videoState')
export const videoState = () =>
  reactive<VideoState>({
    timecode: 0,
    playState: 'stopped'
  })

export const useVideoState = () => inject(VideoStateKey)
export const provideVideoState = () => provide(VideoStateKey, videoState())
